<script lang="ts" setup>
  import { ref, computed } from "vue";
  import { useStore } from "vuex";

  const store = useStore();
  const expanded = ref<Array<any>>([]);

  const content = computed(() => store.state.gon.sidebar?.content);
  const currentPath = computed(() => window.location.pathname);

  const toggle = (index: number) => {
    expanded.value[index] = !expanded.value[index];
  };
  const isExpanded = (index: number) => {
    if(typeof(expanded.value[index]) === 'undefined' && initiallyExpanded(index)) {
      // sideeffect!
      expanded.value[index] = true;
    }
    return !!expanded.value[index];
  };
  const isActive = (entry: any) => {
    return entry.target && !entry.expand && ((entry.target ?? '').split('?')[0] === currentPath.value);
  };
  const initiallyExpanded = (index: number) => {
    if (content == undefined) return false;
    return content
      .value[index]
      .children
      .filter((child: any) => !!child)
      .map((child: any) => [child, ...(child.expand || [])])
      .flat()
      .some((entry:any) => isActive(entry));
  };
</script>

<template>
  <div id="sidebar-navigation" class="components__side-bar print--hide" v-if="content">
    <div class="menu-button-close">
      <a href="#sidebar-navigation-close">
        <i class="frontend-icon fi-fa_times"></i>
      </a>
    </div>
    <template v-for="(section, index) in content" v-bind:key="index">
      <div class="title" v-bind:title="section.title" v-bind:class="{'extra-top-space': (index !== 0), 'title--accordion': section.accordion }" v-on:click="toggle(index)">
        <span class="title__label">{{ section.title }}</span>
        <i v-if="section.accordion" class="frontend-icon" v-bind:class="{'fi-expand_more': !isExpanded(index), 'fi-expand_less': isExpanded(index)}"></i>
      </div>
      <div v-if="section.children && (!section.accordion || isExpanded(index))" class="entries">
        <template v-for="(entry, indexEntry) in section.children" v-bind:key="indexEntry">
          <template v-if="entry">
            <div
              class="entry"
              v-bind:class="{active: isActive(entry)}"
            >
              <a v-if="entry.target && !entry.expand" v-bind:href="entry.target">{{entry.label}}</a>
              <span class="entry-without-target" v-else>{{entry.label}}</span>
            </div>
            <template v-if="entry.expand">
              <div
                v-for="(subentry, indexSubentry) in entry.expand"
                v-bind:key="indexSubentry"
                class="sub-entry"
                v-bind:class="{active: isActive(subentry)}"
              >
                <a v-bind:href="subentry.target">{{subentry.label}}</a>
              </div>
            </template>
          </template>
        </template>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import "~stylesheets/frontend/variables/components/side-bar";
@import "~stylesheets/frontend/variables/components/top-bar";
@import "~stylesheets/frontend/variables/colors";

@import "~include-media/dist/include-media";

$breakpoints: (
  "sidebar": $side-bar_breakpoint,
);

.components__side-bar {
  &#sidebar-navigation {
    width: $side-bar_width;
    min-width: $side-bar_width;
    min-height: calc(100vh - #{$top-bar_height});
    box-sizing: border-box;

    &:target {
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      z-index: 99;

      width: 100%;
      height: 100%;

      .menu-button-close {
        display: block;
      }
    }
  }

  $_sidebar_padding-left: 21px;

  .menu-button-close {
    display: none;
    padding-left: $_sidebar_padding-left;
  }

  background-color: $color-white;
  padding-top: 17px;

  .title {
    margin-left: $_sidebar_padding-left;
    margin-top: 12px;
    margin-bottom: 21px;
    font-size: 18px;
    color: $color-green;

    display: flex;
    align-items: center;

    &.extra-top-space {
      margin-top: 52px;
    }
  }

  .title__label {
    display: inline-block;
    overflow:hidden;
    text-overflow: ellipsis;
    white-space:nowrap;

    @include media(">=sidebar") {
      width: 212px;
    }
  }

  .title--accordion {
    user-select: none;
    cursor: pointer;
  }

  .entries {
    div {
      color: $color-default;
    }
  }

  .entry,
  .sub-entry {
    $_entry-border: 1px solid $color-black-very-light;
    padding-left: $_sidebar_padding-left;
    border-top: $_entry-border;
    padding-top: 14px;
    padding-bottom: 14px;
    padding-right: 10px;

    &:last-of-type {
      border-bottom: $_entry-border;
    }

    &.active {
      background-color: $color-green-hueish;
    }

    &.sub-entry {
      padding-left: $_sidebar_padding-left + 15px;
      color: $color-white_secondary-text;
    }
  }
}
</style>
